module.exports = __webpack_public_path__ + "img/cubs-logo.56d326fc.svg";